import { render, staticRenderFns } from "./ChangelogPage.vue?vue&type=template&id=2cdf5e86"
import script from "./ChangelogPage.vue?vue&type=script&lang=js"
export * from "./ChangelogPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports